import window from "inputmask/lib/global/window";
import {cleverPhoneMask} from "../../common/validation";

const $ = require('jquery');
require('inputmask');
import { popupInit, popupOpenInit } from 'new_design/mobile/common/popup';

const authInit = function () {
  let smsCount = 0;
  let loginAttemptCount = 0;
  let registerAttemptCount = 0;
  const sms_code_timer = $('.sms-code-timer');
  const sms_notification = $('#user-phone-sms');
  const sms_code_field = $('.sms-code-field input');
  $(function () {
    $('#auth-link').hide();
    checkCurrentUser();
    popupInit();

    const PHONE_MASK = "+7 (999) 999-99-99";
    const CODE_MASK = "999999";
    Inputmask({mask: PHONE_MASK, showMaskOnHover: false}).mask($('#auth-register-form-phone'));
    Inputmask({mask: CODE_MASK, showMaskOnHover: false}).mask($('#auth-register-form-code'));
    Inputmask({mask: CODE_MASK, showMaskOnHover: false}).mask($('#auth-login-form-code'));

    $('#auth-login').keypress(function(e) {
      if ((e.key === '+' || e.key === ' ') && $(this).val().length === 0) {
        e.preventDefault();
        return false;
      }
    });

    $('#auth-login').on('keyup', cleverPhoneMask);

    $('#auth-popup .popup-tabs__tab').click(function () {
      $('.sms-code-field').hide();
      $('#user-phone-sms').parent().hide();
      sms_code_timer.hide();
      if ($(this).hasClass('popup-tabs__tab-active')) return;
      $('#auth-popup .popup-tabs__tab').removeClass('popup-tabs__tab-active');
      $(this).addClass('popup-tabs__tab-active');
      $('#auth-popup .auth-form').hide();
      $(`#auth-popup #${$(this).data('target')}`).show();
    })

    function login () {
      smsCount++;
      $('#auth-login-btn').addClass('button-disabled');
      const login = $('#auth-login').val();
      $.ajax({
        url: '/auth/login',
        data: {
          login: login
        },
        type: 'post',
        xhrFields: { withCredentials: true },
        beforeSend: function(xhr){
          xhr.withCredentials = true;
          xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
        },
        success: function (result) {
          if (result.camp_manager_email) {
            const urlParams = new URLSearchParams(window.location.search);
            urlParams.set('email', result.camp_manager_email);
            window.location.href = `https://mirturbaz.ru/users/sign_in?${urlParams}`;
          } else {
            sms_code_field.attr('id', 'auth-login-form-code');
            sms_code_field.attr('name', 'auth-login-form-code');
            sms_code_timer.show();
            sms_code_timer.attr('id', 'auth-login-resend');
            $('#auth-popup .auth-form').hide();
            $('[name="auth-login-form-code"]').closest('.sms-code-field').show();
            $(`#auth-popup #auth-login-code-form`).show();
            sms_notification.parent().show();
            sms_notification.text(login);
            initResendTimer($(`#auth-login-resend`));
          }

          sendSmsMetric({
            result: 'successed',
            purpose: 'authorization',
            phone: login
          });
        },
        error: function (result) {
          addError($('#auth-login'), result);

          const error = JSON.parse(result.responseText);
          sendSmsMetric({
            result: 'failed',
            purpose: 'authorization',
            phone: login,
            error: result.statusText,
            errorName: error.error
          });
        },
        complete: function () {
          $('#auth-login-btn').removeClass('button-disabled');
          $('.sms-code-field').attr('name', '');
        }
      })
    }

    function vk_login () {
      loginAttemptCount++;
      $.ajax({
        url: '/auth/vk_login',
        type: 'get',
        success: function (result) {
          loginMetric({
            result: 'successed',
            method: 'vk'
          });

          location.assign(result.url);
        },
        error: function (result) {
          addError($('#auth-login'), result);

          loginMetric({
            result: 'failed',
            method: 'vk',
            error: result.statusText,
            errorName: 'Произошла ошибка'
          });
        },
        complete: function () {
        }
      })
    }

    $('#vk-auth-login-btn').click(vk_login);

    $('#auth-login-btn').click(login);
    $('#auth-login-form').submit(function (e) {
      e.preventDefault();
      login();
    })

    function loginCheckCode () {
      loginAttemptCount++;
      $('#auth-login-code-btn').addClass('button-disabled');
      $.ajax({
        url: '/auth/login_check_code',
        data: {
          password: $('#auth-login-form-code').val(),
        },
        type: 'post',
        xhrFields: { withCredentials: true },
        beforeSend: function(xhr){
          xhr.withCredentials = true;
          xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
        },
        success: function (result) {
          loginMetric({
            result: 'successed',
            method: 'phone',
            phone: result.phone,
            clientId: result.client_id
          });

          if (window.location.pathname === `${window.website_prefix}/account/favorites`) {
            reloadWithoutParams();
          } else {
            reloadWithCleanedParams();
          }
        },
        error: function (result) {
          addError($('#auth-login-form-code'), result);

          const error = JSON.parse(result.responseText);
          loginMetric({
            result: 'failed',
            method: 'phone',
            phone: error.phone,
            clientId: error.client_id,
            error: result.statusText,
            errorName: error.error
          });
        },
        complete: function () {
          $('#auth-login-code-btn').removeClass('button-disabled');
        }
      })
    }

    $('#auth-login-code-btn').click(loginCheckCode);
    $(`#auth-popup #auth-login-code-form`).submit(function (e) {
      e.preventDefault();
      loginCheckCode();
    });

    $('#auth-login-resend').click(function () {
      $.ajax({
        url: '/auth/login_resend_code',
        type: 'post',
        xhrFields: { withCredentials: true },
        beforeSend: function(xhr){
          xhr.withCredentials = true;
          xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
        },
        success: function (result) {
          initResendTimer($(`#auth-login-resend`));
          removeError($('#auth-login-form-code'));
        },
        error: function (result) {
          addError($('#auth-login-form-code'), result);
        }
      })
    })

    function register () {
      smsCount++;
      let login = $('#auth-register-form-phone').val();
      if (!Inputmask.isValid(login, {mask: PHONE_MASK})) {
        addError($('#auth-register-form-phone'), "Проверьте номер телефона");
        return;
      }
      if (!$('#register_confirms').prop('checked')) {
        addError($('#auth-register-form-phone'), "Вы должны принять условия");
        return;
      }
      $('#auth-register-btn').addClass('button-disabled');
      $.ajax({
        url: '/auth/register_send_code',
        data: {
          login: login,
          name: $('#auth-register-form-name').val(),
          last_name: $('#auth-register-form-last-name').val()
        },
        xhrFields: { withCredentials: true },
        type: 'post',
        beforeSend: function(xhr){
          xhr.withCredentials = true;
          xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
        },
        success: function (result) {
          sms_code_field.attr('id', 'auth-register-form-code');
          sms_code_field.attr('name', 'auth-register-form-code');
          sms_code_timer.show();
          $('.sms-code-field input').attr('name', 'auth-register-form-code');
          $('#auth-popup .auth-form').hide();
          $('[name="auth-register-form-code"]').closest('.sms-code-field').show();
          $(`#auth-popup #auth-register-code-form`).show();
          sms_notification.parent().show();
          sms_notification.text(login);
          sms_code_timer.attr('id', 'auth-register-resend');
          initResendTimer($(`#auth-register-resend`));

          sendSmsMetric({
            result: 'successed',
            purpose: 'registration',
            phone: login
          });
        },
        error: function (result) {
          addError($('#auth-register-form-phone'), result);

          const error = JSON.parse(result.responseText);
          sendSmsMetric({
            result: 'failed',
            purpose: 'registration',
            phone: login,
            error: result.statusText,
            errorName: error.error
          })
        },
        complete: function () {
          $('#auth-register-btn').removeClass('button-disabled');
          $('.sms-code-field').attr('name', '');
        }
      })
    }

    $('#auth-register-btn').click(register);
    $('#auth-register-form').submit(function (e) {
      e.preventDefault();
      register();
    })

    $('#auth-register-resend').click(function () {
      $.ajax({
        url: '/auth/register_resend_code',
        type: 'post',
        xhrFields: { withCredentials: true },
        beforeSend: function(xhr){
          xhr.withCredentials = true;
          xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
        },
        success: function (result) {
          initResendTimer($(`#auth-register-resend`));
        },
        error: function (result) {
          addError($('#auth-register-form-code'), result);
        }
      })
    })

    function registerCheckCode () {
      registerAttemptCount++;
      $('#auth-register-code-btn').addClass('button-disabled');
      $.ajax({
        url: '/auth/register_check_code',
        data: {
          password: $('#auth-register-form-code').val(),
        },
        type: 'post',
        xhrFields: {withCredentials: true},
        beforeSend: function (xhr) {
          xhr.withCredentials = true;
          xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
        },
        success: function (result) {
          registerMetric({
            result: 'successed',
            phone: result.phone,
            clientId: result.client_id
          });

          if (window.location.pathname === `${window.website_prefix}/account/favorites`) {
            reloadWithoutParams();
          } else {
            reloadWithCleanedParams();
          }
        },
        error: function (result) {
          addError($('#auth-register-form-code'), result);

          const error = JSON.parse(result.responseText);
          registerMetric({
            result: 'failed',
            phone: error.phone,
            error: result.statusText,
            errorName: error.error
          });
        },
        complete: function () {
          $('#auth-register-code-btn').removeClass('button-disabled');
        }
      })
    }

    $('#auth-register-code-btn').click(registerCheckCode);
    $(`#auth-popup #auth-register-code-form`).submit(function (e) {
      e.preventDefault();
      registerCheckCode();
    })

    function logout() {
      $.ajax({
        url: '/auth/logout',
        type: 'post',
        xhrFields: { withCredentials: true },
        beforeSend: function (xhr) {
          xhr.withCredentials = true;
          xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
        },
        success: function () {
          checkCurrentUser();
          location.reload();
        },
        error: function (error) {
          console.error(error);
        }
      });
    }

    $('.auth-logout').click(logout);

    function updateUIOnLogin(result) {
      $('.auth__name').text(result.name);
      $('#client-menu .bonuses-count').removeClass('hidden').text(result.bonuses_count);
      $('#auth-link').hide();
      $('#client-menu-link').removeClass('hidden');
      $('#menu-login').hide();

      if (window.isMobileDevice) {
        let profileAvatar;
        if (result.photo_url) {
          $('.auth__ico').hide();
          const clientPhoto = $('<img>').attr({
            src: result.photo_url,
            class: 'rounded-image open_popup',
            loading: 'lazy',
            id: 'client-menu-link',
            rel: 'client-menu-popup'
          });

          const activeCountElement = $('<div>').addClass('user-icon__badge active-count').css('display', 'none').text(result.active_books_count);
          profileAvatar = $('<div>').addClass('profile-avatar').append(clientPhoto).append(activeCountElement);
        } else {
          profileAvatar = $('<div>').attr({
            id: 'client-menu-link',
            class: 'auth__ico open_popup',
            rel: 'client-menu-popup'
          });

          const activeCountElement = $('<div>').addClass('user-icon__badge active-count').css('display', 'none').text(result.active_books_count);

          profileAvatar.append(activeCountElement);
        }

        $('.client-photo').before(profileAvatar);

        popupOpenInit();
      } else {
        if (result.photo_url) {
          $('.auth__ico').hide();
          const clientPhoto = $('<img>').attr({
            src: result.photo_url,
            class: 'rounded-image',
            loading: 'lazy'
          });
          $('.auth__name.client-name').before(clientPhoto);
        }
      }

      if (result.active_books_count > 0) {
        $('.active-count').removeClass('hidden').show().text(result.active_books_count);
      }
    }

    function updateUIOnLogout() {
      $('#auth-link').show();
      $('#client-menu-link').addClass('hidden');
      $('#menu-login').show();
      $('.auth__ico').show();

      if (window.isMobileDevice) {
        $('.auth__name').text('Вход в личный кабинет');
      } else {
        $('.auth__name').text('Войти');
      }
    }

    function updateUIVisibility(result) {
      if (result.current_client_present) {
        updateUIOnLogin(result);
      } else {
        updateUIOnLogout();
      }

      if (result.favorite_count && result.favorite_count > 0) {
        $('.favorite-count').removeClass('hidden').show().text(result.favorite_count);
      }
    }

    function checkCurrentUser() {
      $.ajax({
        url: '/auth/check_current_client',
        type: 'get',
        xhrFields: { withCredentials: true },
        success: function (result) {
          updateUIVisibility(result);
          window.client_present = result.current_client_present;
          window.client_is_checked = true;
          document.dispatchEvent(new CustomEvent('client_is_checked'));
        },
        error: function (error) {
          console.error(error);
        }
      });
    }
  })

  function addError($input, error) {
    if (error instanceof Object) {
      error = error?.responseJSON?.error;
    }
    let $wrapper = $input.closest('.mtui-text-field__wrapper');
    $wrapper.find('.mtui-text-field__error-label').show();
    $wrapper.addClass('mtui-text-field_error');
    if (error) {
      $wrapper.find('.mtui-text-field__error-label').text(error);
    } else {
      $wrapper.find('.mtui-text-field__error-label').text("Произошла ошибка");
    }
  }

  function removeError($input) {
    $input.val('');
    let $wrapper = $input.closest('.mtui-text-field__wrapper');
    $wrapper.find('.mtui-text-field__error-label').hide();
    $wrapper.removeClass('mtui-text-field_error');
    $wrapper.find('.mtui-text-field__error-label').text('');
  }

  function initResendTimer ($btn) {
    $btn.addClass('button-disabled');
    clearInterval(window.login_resend_timer);
    let time = 60;
    window.login_resend_timer = setInterval(function () {
      if (time > 0) {
        time -= 1;
        $btn.text(`Отправить новый код (0:${time < 10 ? `0${time}` : time})`);
      } else {
        $btn.text('Отправить новый код');
        $btn.removeClass('button-disabled');
        clearInterval(window.login_resend_timer);
      }

    }, 1000);
  }

  $('.header-menu__auth, #client-menu').hover(function() {
    if (window.client_present) {
      $('#client-menu').removeClass("hidden");
    }
  }, function() {
    $('#client-menu').addClass("hidden");
  });

  function sendSmsMetric({ result, purpose, phone, error = null, errorName = null } = {}) {
    gtag('event', 'auth.sending_sms', {
      'result': result,
      'url': window.location.href,
      'url_without_parameters': window.location.origin + window.location.pathname,
      'phone': phone,
      'sms_counts': Math.max(smsCount - 1, 0),
      'purpose': purpose,
      'error': error,
      'error_name': errorName
    });

    window.ymReachGoal('auth.sending_sms', {
      'result': result,
      'url': window.location.href,
      'url_without_parameters': window.location.origin + window.location.pathname,
      'phone': phone,
      'sms_counts': Math.max(smsCount - 1, 0),
      'purpose': purpose,
      'error': error,
      'error_name': errorName
    });
  }

  function loginMetric({result, method, phone, clientId, error = null, errorName = null} = {}) {
    gtag('event', 'auth.login', {
      'result': result,
      'url': window.location.href,
      'url_without_parameters': window.location.origin + window.location.pathname,
      'method': method,
      'phone': phone,
      'client_id': clientId,
      'attempts': Math.max(loginAttemptCount - 1, 0),
      'sms_counts': Math.max(smsCount - 1, 0),
      'error': error,
      'error_name': errorName
    });

    window.ymReachGoal('auth.login', {
      'result': result,
      'url': window.location.href,
      'url_without_parameters': window.location.origin + window.location.pathname,
      'method': method,
      'phone': phone,
      'client_id': clientId,
      'attempts': Math.max(loginAttemptCount - 1, 0),
      'sms_counts': Math.max(smsCount - 1, 0),
      'error': error,
      'error_name': errorName
    });
  }

  function registerMetric({result, phone, clientId = null, error = null, errorName = null} = {}) {
    gtag('event', 'auth.registration', {
      'result': result,
      'url': window.location.href,
      'url_without_parameters': window.location.origin + window.location.pathname,
      'phone': phone,
      'client_id': clientId,
      'attempts': Math.max(registerAttemptCount - 1, 0),
      'sms_counts': Math.max(smsCount - 1, 0),
      'error': error,
      'error_name': errorName
    });

    window.ymReachGoal('auth.registration', {
      'result': result,
      'url': window.location.href,
      'url_without_parameters': window.location.origin + window.location.pathname,
      'phone': phone,
      'client_id': clientId,
      'attempts': Math.max(registerAttemptCount - 1, 0),
      'sms_counts': Math.max(smsCount - 1, 0),
      'error': error,
      'error_name': errorName
    });
  }

  function reloadWithoutParams() {
    const url = new URL(window.location);
    url.search = "";
    window.location.href = url.toString();
  }

  function reloadWithCleanedParams() {
    const url = new URL(window.location.href);
    if (url.searchParams.has('show_login')) {
      url.searchParams.delete('show_login');
      window.location.href = url.toString();
    } else {
      window.location.reload();
    }
  }
}

function initAuthAction() {
  let $discountBanner = $('#main-banner-discount');
  if (!$discountBanner.length) {
    $discountBanner = $('.banner.banner_discount');
    if (!$discountBanner.length) return;
  }

  const $bannerLink = $discountBanner.find('a');
  if (!$bannerLink.length) return;

  if (window.client_present) {
    $bannerLink.attr('rel', null);
    $bannerLink.removeClass('open_popup');
  } else {
    $bannerLink.attr('href', null);
  }
}


export { authInit, initAuthAction };
